import React from 'react'

function CheckboxCheckedIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.66797 10.0001C1.66797 6.07171 1.66797 4.10752 2.88836 2.88714C4.10875 1.66675 6.07293 1.66675 10.0013 1.66675C13.9297 1.66675 15.8939 1.66675 17.1142 2.88714C18.3346 4.10752 18.3346 6.07171 18.3346 10.0001C18.3346 13.9285 18.3346 15.8926 17.1142 17.113C15.8939 18.3334 13.9297 18.3334 10.0013 18.3334C6.07293 18.3334 4.10875 18.3334 2.88836 17.113C1.66797 15.8926 1.66797 13.9285 1.66797 10.0001Z" fill="currentColor" stroke="currentColor" strokeWidth="1.2" />
      <path d="M7.08203 10.4167L8.7487 12.0834L12.9154 7.91675" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}


export default CheckboxCheckedIcon